import DashboardLayout from '@/views/Theme/Layout/DashboardLayout.vue';
import NotFound from '@/views/Theme/GeneralViews/NotFoundPage.vue';

const Login = () =>
    import( /* webpackChunkName: "login" */ '@/views/Pages/Login');
const ForgotPassword = () =>
    import( /* webpackChunkName: "ForgotPassword" */ '@/views/Pages/ForgotPassword');
const RecoverPassword = () =>
    import( /* webpackChunkName: "RecoverPassword" */ '@/views/Pages/RecoverPassword');
const DispatchPanel = () =>
    import( /* webpackChunkName: " DispatchPanel" */ '@/views/Dispatch/DispatchPanel');
const DriversMap = () =>
    import( /* webpackChunkName: " DriversMap" */ '@/views/DriversMap/DriversMap');
const Profile = () =>
    import( /* webpackChunkName: " Profile" */ '@/views/Pages/UserProfile/UserProfile');

const routes = [

    {
        path: '/',
        component: Login,
        redirect: '/login',
        name: 'home',
        children: [{
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false
            },
        }]
    },
    {
        name: 'Forgot Password',
        path: '/forgot-password',
        component: ForgotPassword,
        meta: {
            requiresAuth: false
        },
    },
    {
        name: 'Recover Password',
        path: '/recover-password',
        component: RecoverPassword,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dispatch-panel',
        name: 'Dashboard layout',
        children: [{
            name: 'DispatchPanel',
            path: '/dispatch-panel',
            component: DispatchPanel,
            meta: {
                requiresAuth: true
            }
        },
        {
            name: 'DriversMap',
            path: '/drivers-map',
            component: DriversMap,
            meta: {
                requiresAuth: true
            }
        },
        {
            name: 'Profile',
            path: '/profile',
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        ]
    },
    {
        path: '*',
        component: NotFound
    }
];

export default routes;